import { Reducer } from 'redux'
import { PersonRolesState } from '@models/person-role';
import { PersonRolesActionTypes } from "@actions/person-role";

// Type-safe initialState!
export const initialState: PersonRolesState = {
    data: [],
    errors: undefined,
    loading: false,
    count: 0
};

const reducer: Reducer<PersonRolesState> = (state = initialState, action) => {
  switch (action.type) {
      case PersonRolesActionTypes.FETCH_REQUEST: {
          return {
              ...state,
              loading: true
          }
      }

      case PersonRolesActionTypes.FETCH_SUCCESS: {
          const{data, meta} = action.payload;
          return {
              ...state,
              loading: false,
              data,
              count: meta.total_count
          }
      }

      case PersonRolesActionTypes.FETCH_ERROR: {
          return { ...state, loading: false, errors: action.payload.error }
      }

      case PersonRolesActionTypes.DELETE_SUCCESS:{
          return{
              ...state,
              data : state.data.filter( person => person.id != action.payload.params.id),
              count: state.count - 1
          }
      }

      case PersonRolesActionTypes.CREATE_SUCCESS:{
          const role = action.payload;
          return{
              ...state,
              data : [role, ...state.data],
              count: state.count + 1
          }
      }

      case PersonRolesActionTypes.UPDATE_SUCCESS:{
          const role = action.payload;
          return{
              ...state,
              data : state.data.map( item => (item.id == role.id) ? {
                  ...item,
                  ...role
              } : item ),
          }
      }


      default: {
      return state
    }
  }
};

export { reducer as personRoleReducer }
